module.exports = __webpack_public_path__ + "img/1 6-1.6682a026.png";